import { useTranslation } from '@/features/shared/composables/useTranslation'
import { ACCOUNT_TYPE } from '@/features/shared/constants/accountType'

const t = useTranslation()

export const exportsRoutes = [
  {
    path: 'analytics/exports',
    name: 'Exports',
    component: () => import('@/features/exports/views/Exports.vue'),
    meta: {
      title: `${t('exports')} | PourNow`,
      visibleAccountTypes: [ACCOUNT_TYPE.BRAND],
    },
  },
]
